import React, { FC } from "react";
import Box from "@mui/material/Box";
import { Outlet } from "react-router-dom";
import AppHeader from "./AppHeader";
import MyFooter from "../footer";
import { useAuth } from "../../hooks/use-auth";

/**
 * Page shell: header, page, footer — declared once here rather than repeated by
 * every route component.
 *
 * The document scrolls normally now; the old `#root { overflow: hidden }` lock
 * is gone, along with the `calc(100vh - Npx)` crops it forced on inner
 * containers.
 */
const AppLayout: FC = () => {
  const user = useAuth();

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
        bgcolor: "background.default",
      }}
    >
      <AppHeader showActions={Boolean(user)} />
      <Box component="main" sx={{ flex: 1 }}>
        <Outlet />
      </Box>
      <MyFooter />
    </Box>
  );
};

export default AppLayout;
